/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const url = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/';
const SandStoneLargePot = `${url}bltc945d298d1461cb7/63c9534bdd49ff3d9fff2351/sandstone-pot-large.png`;
const SandStoneMediumPot = `${url}bltf40c9005152d4d5c/63c9539704062b163ae4ed8b/sandstone-pot-medium.png`;
const SandStoneSmallPot = `${url}bltaef715880a89051e/63c954c69deb3f643ee463be/sandstone-pot-small.png`;
const DomainLargePot = `${url}bltc9693e3948177672/63c95a3fcb2b29167d2e5938/domain-pot-large.png`;
const DomainMediumPot = `${url}blt7d05ce3f3bdfaf56/63c95a3edd49ff3d9fff2367/domain-pot-medium.png`;
const DomainSmallPot = `${url}blt14bc63cee4d9c25b/63c95a40ca4ee4418bab9d25/domain-pot-small.png`;
const EclipseLargePot = `${url}blt5737b2c4bc2b5b7d/63c95a7071ee3810f4293337/eclipse-pot-large.png`;
const EclipseMediumPot = `${url}blt90dcffca2b45cc0f/63c95a7027d0de75938fc2ed/eclipse-pot-medium.png`;
const ArtisanLargePot = `${url}blta70a045247b5c765/63c95aa80f5896167c71cfd9/artisan-pot-large.png`;
const ArtisanMediumPot = `${url}blt88f149c78d84334b/63c95aa765b0e343317478f4/artisan-pot-medium.png`;
const ArtisanSmallPot = `${url}blt1b9738a0c5a07ab6/63c95aa781b45d107000f8ae/artisan-pot-small.png`;

export default function SizeCollectionData(showAllPlantersSizeChart) {
    if (showAllPlantersSizeChart) {
        return [
            {
                title: 'Sandstone Planter',
                planterFeatures: ['Exclusive, versatile sandstone planter comes in three sizes.', 'Ribbed border detail at rim; contoured base; watertight.'],
                planterDetails: [
                    {
                        type: 'Large',
                        imageSource: SandStoneLargePot,
                        size: 'Sandstone 10”',
                        dimentions: ['Length: 11.6”', 'Width: 11.6”', 'Height: 9.6”'],
                    },
                    {
                        type: 'Medium',
                        imageSource: SandStoneMediumPot,
                        size: 'Sandstone 6”',
                        dimentions: ['Length: 7.5”', 'Width: 7.5”', 'Height: 5.7”'],
                    },
                    {
                        type: 'Small',
                        imageSource: SandStoneSmallPot,
                        size: 'Sandstone 4”',
                        dimentions: ['Length: 5.5”', 'Width: 5.5”', 'Height: 4.2”'],
                    },
                ],
            },
            {
                title: 'Domain Planter',
                planterFeatures: ['Exclusive versatile, neutral planter with pedestal base; break-resistant and watertight.', 'Wood stand included.', 'Available in choice of colors – Snowcap, Granite, Midnight, Rust.'],
                planterDetails: [
                    {
                        type: 'Large',
                        imageSource: DomainLargePot,
                        size: 'Domain 10”',
                        dimentions: ['Length: 11.5”', 'Width: 11.5”', 'Height (NO STAND): 9.7”', 'Height with stand low setting: 14”', 'Height with stand high setting: 16”'],
                    },
                    {
                        type: 'Medium',
                        imageSource: DomainMediumPot,
                        size: 'Domain 6”',
                        dimentions: ['Length: 7”', 'Width: 7”', 'Height (NO STAND): 5”', 'Height with stand low setting: 9”', 'Height with stand high setting: 10”'],
                    },
                    {
                        type: 'Small',
                        imageSource: DomainSmallPot,
                        size: 'Domain 4”',
                        dimentions: ['Length: 4.75”', 'Width: 4.75”', 'Height (NO STAND): 4.2”', 'Height with stand low setting:  7”', 'Height with stand high setting: 7.5”'],
                    },
                ],
            },
            {
                title: 'Eclipse Planter',
                planterFeatures: ['Exclusive pink ceramic planter, watertight. Satin Finish. Slanted top rim detail.'],
                planterDetails: [
                    {
                        type: 'Large',
                        imageSource: EclipseLargePot,
                        size: 'Eclipse 6”',
                        dimentions: ['Length: 7”', 'Width: 7”', 'Height: 5.5” (lowest point), 6.7” (highest point)'],
                    },
                    {
                        type: 'Medium',
                        imageSource: EclipseMediumPot,
                        size: 'Eclipse 4”',
                        dimentions: ['Length: 5”', 'Width: 5”', 'Height: 4.6” (lowest point), 5.5” (highest point)'],
                    },
                ],
            },
            {
                title: 'Artisan Planter',
                planterFeatures: ['Exclusive banana leaf woven basket with handless with sewn in liner + plastic liner for added protection agianst leakage.'],
                planterDetails: [
                    {
                        type: 'Large',
                        imageSource: ArtisanLargePot,
                        size: 'Artisan 10”',
                        dimentions: ['Length: 11.4”', 'Width: 11.4”', 'Height: 10.2” (No handle), 13.7” (WITH Handle)'],
                    },
                    {
                        type: 'Medium',
                        imageSource: ArtisanMediumPot,
                        size: 'Artisan 6”',
                        dimentions: ['Length: 7.5”', 'Width: 7.5”', 'Height: 5.9” (No handle), 8.25” (WITH Handle)'],
                    },
                    {
                        type: 'Small',
                        imageSource: ArtisanSmallPot,
                        size: 'Artisan 4”',
                        dimentions: ['Length: 5.5”', 'Width: 5.5”', 'Height: 5.1” (No handle), 6.7” (WITH Handle)'],
                    },
                ],
            },
        ];
    }
    return [
        {
            title: 'Sandstone Planter',
            planterFeatures: ['Exclusive, versatile sandstone planter comes in three sizes.', 'Ribbed border detail at rim; contoured base; watertight.'],
            planterDetails: [
                {
                    type: 'Large',
                    imageSource: SandStoneLargePot,
                    size: 'Sandstone 10”',
                    dimentions: ['Length: 11.6”', 'Width: 11.6”', 'Height: 9.6”'],
                },
                {
                    type: 'Medium',
                    imageSource: SandStoneMediumPot,
                    size: 'Sandstone 6”',
                    dimentions: ['Length: 7.5”', 'Width: 7.5”', 'Height: 5.7”'],
                },
                {
                    type: 'Small',
                    imageSource: SandStoneSmallPot,
                    size: 'Sandstone 4”',
                    dimentions: ['Length: 5.5”', 'Width: 5.5”', 'Height: 4.2”'],
                },
            ],
        },
    ];
}
